<template>
  <div v-click-outside="close" class="dropdown">
    <div class="bordered-input">
      <div :class="isOpen?'dropdown__input focus':'dropdown__input'" @click="toggleDisplay">
        <div class="dropdown__input--text">
          {{ getLabel }}
        </div>
        <div v-if="isOpen" class="icon caret-up" />
        <div v-else class="icon caret-down" />
      </div>
    </div>
    <Transition v-show="isOpen" name="slide-fade">
      <div v-show="isOpen" class="dropdown__container">
        <Guests />
      </div>
    </Transition>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { _ } from 'vue-underscore';
import Bus from '../../events/bus';
import responsive from '../../mixins/responsive.js';
import Guests from '../../pages/results/filters/Guests';

export default {
  name: 'GuestsDropdown',
  components: {
    Guests,
  },
  directives: {
    ClickOutside,
  },
  mixins: [responsive],
  props: {
    searchVillaId: { type: Number, default: 3 },
  },
  data() {
    return {
      labelText: 'Add guests',
      isOpen: false,
    };
  },
  computed: {
    getGuestsCount() {
      return this.$store.getters['results/getPeople'];
    },
    getLabel() {
      if (this.getGuestsCount == 0) {
        this.labelText = 'Add guests';
      }
      if (this.getGuestsCount == 1) {
        this.labelText = `${this.getGuestsCount} guest`;
      }
      if (this.getGuestsCount > 1) {
        this.labelText = `${this.getGuestsCount} guests`;
      }

      return this.labelText;
    },
  },
  mounted() {
    Bus.$on('closeSearchVillaTabs', this.closeTab);
  },
  methods: {
    toggleDisplay() {
      this.isOpen = !this.isOpen;
      this.isOpen ? Bus.$emit('closeSearchVillaTabs', this.searchVillaId) : null;
    },
    closeTab(id) {
      if (id != this.searchVillaId) {
        this.isOpen = false;
      }
    },
    close() {
      if (this.isDesktop) {
        this.isOpen = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/settings/config.scss";

  .dropdown {
    position: relative;
    text-align: left;

    &__input {
      width: 100%;
      height: 70px;
      background-color: $limeStone;
      /*border: 1px solid $solitude;*/
      /*border-radius: 8px;*/
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;
      cursor: pointer;

      &--text {
        color: $darkBlack;
      }

      &.focus {
        background-color: $stoneCream;
      }

      .mobile-search-villa__container & {
        background-color: $stoneWhite;

        &.focus {
          background-color: $stoneWhite;
        }
      }
    }

    &__container {
      position: absolute;
      z-index: 10;
      min-width: 315px;
      width: 100%;
      left: -1px;
      padding: 0 24px;
      background: $limeStone;
      border: 1px solid $stoneLight;

      .search-villa--sticky &,
      .search-villa--dropdown-top & {
        bottom: 70px;
      }

      .mobile-search-villa__container & {
        margin-top: 8px;
        background: $stoneWhite;
        border: 1px solid $yellowStone;
      }

      @include desktop-ms-down {
        min-width: 325px;
      }

      @include tablet-down {
        padding: 10px;
        left: 0px;
        width: 100%;
        min-width: 290px;
        margin-top: 5px;
      }

      @include mobile-sm-down {
        width: 100%;
        min-width: 290px;
        padding: 10px;
        left: 0px;
      }
    }

    .icon {
      cursor: pointer;

      &.caret-up {
        background-image: url(../../assets/img/src/icons/chevron-up.svg);
        background-size: 13px 13px;
        width: 13px;
        height: 13px;
      }

      &.caret-down {
        background-image: url(../../assets/img/src/icons/chevron-down.svg);
        background-size: 13px 13px;
        width: 13px;
        height: 13px;
      }
    }
  }
</style>
